import React from 'react';
import PropTypes from 'prop-types';

import SVGIcon from './svg-icon';

/**
 * Uniform Dependencies
 * @requires css:components/icons
 * @requires css:components/forms
 */
export default class UrlInputComponent extends React.Component {
  handleChange(evt) {
    const { changeCallback } = this.props;

    const input = evt.target.value.trim();
    let output = input;

    if (!/^(?:f|ht)tps?:\/\//i.test(input) && 'http://'.indexOf(input) === -1) {
      output = 'http://' + input;
    }

    if (changeCallback) {
      changeCallback(output)
    }
  }

  render () {
    const { reference, id, defaultValue, required } = this.props;

    return (
      <div className='icon input'>
        <SVGIcon name='link' />
        <input
          ref={reference}
          id={id}
          type='url'
          value={defaultValue}
          onChange={this.handleChange.bind(this)}
          required={required}
        />
      </div>
    );
  }
}

UrlInputComponent.propTypes = {
  changeCallback: PropTypes.func,
  defaultValue: PropTypes.string,
  id: PropTypes.string.isRequired,
  reference: PropTypes.string,
  required: PropTypes.bool
};

UrlInputComponent.defaultProps = {
  reference: '',
  defaultValue: '',
  required: false
};



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/components/url-input.js